module.exports = __webpack_public_path__ + "img/FR19106.de595f02.svg";